import React from "react";

export const IniEstudiante=()=>{
    return <>
    <a>hey</a>
    </>
}